module.exports = __webpack_public_path__ + "img/size.71997e25.png";